// extracted by mini-css-extract-plugin
export default {"label":"manageableField_label__cO3fQ"};